import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.data-table {
    background: #ffffff;
}
/* stylelint-disable */
/**
 * ag grid surreptitiously disables select + copy and paste
 * on all grids.
 * this gives us this default browser behavior back
 */
.data-table :global(*) {
    user-select: initial !important;
    -moz-user-select: text !important;
    -ms-user-select: text !important;
    -webkit-user-select: text !important;
}
.ag-box-container :global(.select-fund) {
    background-color: rgba(8, 110, 161, 0.04);
}
/* stylelint-enable */
.ag-box-container,
.ag-box-container
    :global(.ag-header, .ag-header-group-cell, .ag-pinned-left-header, .ag-header-viewport
        .ag-header-cell) {
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.08);
}
.ag-box-container :global(.ag-pinned-left-header) {
  z-index: 1;
}
.ag-box-container.all-holdings :global(.ag-pinned-left-header) {
  z-index: 0;
}
.ag-box-container.all-holdings :global(.ag-pinned-left-header .ag-header-cell) {
    border-right: 0.25px solid #f0f0f0;
}
.ag-box-container :global(.ag-header-group-cell, .ag-header-cell) {
    background: #ffffff;
}
.ag-box-container :global(.sticky-header) {
    position: fixed;
    top: calc(8px * 5);
    background-color: #ffffff;
  z-index: 2;
}
.ag-box-container.all-holdings :global(.ag-header-cell-text) {
    font-weight: bold;
    width: 100%;
}
.ag-box-container.all-holdings
    :global(.ag-header-cell-number .ag-header-cell-label) {
    justify-content: flex-end;
}
.ag-box-container.all-holdings
    :global(.ag-header-cell-number .ag-header-cell-label .text) {
    margin-left: 10%;
}
.ag-box-container.all-holdings :global(.ag-row, .ag-header-row) {
    font-size: 14px;
}
.ag-box-container.all-holdings :global(.ag-cell-value-text) {
    justify-content: left;
}
.ag-box-container.all-holdings :global(.ag-cell-value-number) {
    padding-right: 1.5%;
}
.ag-box-container :global(.ag-header-group-cell-with-group) {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(8px * 6);
    /* stylelint-disable declaration-property-value-blacklist */
    z-index: 1;
    /* stylelint-enable declaration-property-value-blacklist */
    box-shadow: none;
}
.ag-box-container :global(.ag-header-group-cell-label) {
    white-space: initial;
    text-align: center;
    overflow: visible;
}
.ag-box-container :global(.ag-row-hover) {
    background-color: #f8f8f8;
}
.ag-box-container :global(.ag-row, .ag-header-row) {
  font-family: 'Nimbus Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
    font-size: 14px;
    font-family: 'Nimbus Sans Condensed', 'Nimbus Sans Light',
        'Nimbus Sans Con', sans-serif;
    color: #3b3b3b;
}
.ag-box-container :global(.ag-header-cell) {
  padding: 0 7px 0 7px;
  border-left: none;
  border-right: none;
  font-family: 'Nimbus Sans Condensed', 'Nimbus Sans Light',
        'Nimbus Sans Con', sans-serif;
}
.ag-box-container :global(.ag-cell) {
    border-top: 1px solid #ebebeb;
  padding: 0 7px 0 7px;
  border-left: none;
  border-right: none;
  font-family: 'Nimbus Sans Condensed', 'Nimbus Sans Light',
        'Nimbus Sans Con', sans-serif;
}
.ag-box-container :global(.ag-cell-label-container) {
    width: 100%;
}
.ag-box-container :global(.ag-header-cell-label) {
    /* background: var(--module-white); */
    font-size: 14px;
    font-weight: 400;
    display: flex;
    justify-content: space-between;
}
.ag-box-container :global(.sub-label) {
    font-size: 14px;
}
.ag-box-container :global(.ag-buy-button) {
    justify-content: center;
}
.ag-box-container :global(.ag-cell-value-number) {
    justify-content: flex-end;
}
.ag-box-container :global(.ag-react-container) {
    width: 100%;
}
.ag-box-container
    :global(.ag-header-cell, .ag-row .row-value, .ag-row .row-label) {
    display: flex;
    align-items: center;
}
.ag-box-container :global(.ag-sort-ascending-icon) {
    position: relative;
}
.ag-box-container :global(.ag-pinned-left-cols-container) {
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1),
            0 2px 5px 0 rgba(0, 0, 0, 0.1);
}
.ag-box-container :global(.row-title) {
    padding: 4px 0;
}
.ag-box-container :global(.ag-cell-label-container),
.ag-box-container :global(.ag-row .ag-cell) {
    white-space: normal;
}
.ag-box-container :global(.ag-overlay .ag-overlay-loading-center) {
  font-family: 'Nimbus Sans Condensed', 'Nimbus Sans Light',
        'Nimbus Sans Con', sans-serif;
  font-style: normal;
}
.ag-box-container
    :global(.ag-header-cell-label .icons, .ag-header-cell-label .text) {
  display: flex;
  align-items: center;
    flex-direction: column;
    justify-content: center;
}
.ag-box-container :global(.ag-header-cell-label .text) {
    /* padding-left: var(--header-label-padding-left); */
}
.ag-box-container :global(.ag-react-container .ag-action-column) {
    display: flex;
}
.ag-box-container :global(.tax-efficient .link) {
    display: flex;
    justify-content: center;
    text-decoration: none;
    color: #086ea1;
    cursor: pointer;
}
.ag-box-container :global(.ag-center-cols-viewport) {
    overflow-x: hidden;
}
/* *** This is required to render ag-grid table 
       for environments other than sandbox */
.ag-box-container :global(.ag-root-wrapper-body.ag-layout-normal) {
    height: 100%;
}
.export-wrapper {
    width: 100%;
    text-align: right;
    margin-bottom: 8px;
    position: relative;
}
.export-wrapper button {
    color: #086ea1;
    position: absolute;
    right: 0px;
    font-family: 'Nimbus Sans Condensed', 'Nimbus Sans Light',
        'Nimbus Sans Con', sans-serif;
    padding: 8px;
    top: -43px;
    /* @apply --layer-2; */
    /* stylelint-disable declaration-property-value-blacklist */
    z-index: 12;
    /* stylelint-enable declaration-property-value-blacklist */
}
.export-wrapper button:hover {
    text-decoration: underline;
}
.export-wrapper button:focus {
    border: solid 2px #000000;
    text-decoration: underline;
}
/* Needed to fix a very specific 
 * horizontal scrollbar bug within 
 * the ag-grid-react dependency */
/* stylelint-disable */
@media only screen and (max-width: 1128px) {
    .ag-box-container :global(.ag-center-cols-viewport) {
        overflow-x: auto;
    }
}
/* stylelint-enable */
@media (max-width: 720px) {
    .export-wrapper {
        display: none;
    }
}
`;

export default styles;